<script>
import BrandedTextElementProduction
  from "%/dynamic-component-editor/standard-elements/text-element/BrandedTextElementProduction.vue";
import BrandedTextOptions from "%/dynamic-component-editor/bundles/branded-text-options";

export default {
  name: "BrandedNoteElementProduction",
  // Production twin: exempt from the palette's elementPanelSettings gate.
  production: true,
  extends: BrandedTextElementProduction,
  optionBundles: [
    new BrandedTextOptions({
      "default.text-style-option": "note",
    }),
  ],
};
</script>
